export default __webpack_public_path__ + "static/media/amaze-5.7bb9f109.jpg";